import { Navigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AdminGuard({ children, allowedRoles }) {
  // Felhasználói munkamenet lekérése
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      // Betöltőképernyő megjelenítése animációval
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-red-50 dark:from-gray-900 dark:to-gray-800 transition-colors">
        <div className="text-center p-8">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-orange-200 dark:border-orange-900 border-t-orange-600 dark:border-t-orange-500 mx-auto mb-6"></div>
          <p className="text-xl font-semibold text-gray-700 dark:text-gray-300 transition-colors">Betöltés...</p>
        </div>
      </div>
    );
  }

  // Vendég felhasználók átirányítása
  if (!user) return <Navigate to="/bejelentkezes" replace />;
  
  // Engedélyezett szerepkörök definiálása
  const rolesToCheck = allowedRoles || ['Fodrász', 'Rendszergazda'];
  
  if (!rolesToCheck.includes(user.role)) {
    return (
      // Tiltó felület jogosultság hiányában
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-orange-50 dark:from-gray-900 dark:to-gray-800 transition-colors">
        <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-3xl p-12 shadow-2xl text-center border border-red-200 dark:border-red-900/30 transition-colors">
          <div className="text-7xl mb-8 mx-auto">🚫</div>
          <h2 className="text-4xl font-bold text-gray-800 dark:text-white mb-6 transition-colors">Nincs jogosultságod</h2>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-12 leading-relaxed transition-colors">
            Ez az oldal kizárólag a megfelelő jogosultsággal rendelkező munkatársak számára érhető el.
          </p>
          <Link 
            to="/profil" 
            className="inline-block bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white font-semibold px-8 py-3.5 rounded-2xl shadow-lg transition-all text-sm tracking-wide"
          >
            Vissza a profilomra
          </Link>
        </div>
      </div>
    );
  }

  // Megfelelő jogosultság esetén tartalom visszaadása
  return children;
}